import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, logout: async () => {} });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (err) {
      // 401 is expected when not authenticated; surface other errors for debugging
      if (err?.response?.status !== 401) {
        console.error("Auth: /auth/me failed", err);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Best-effort logout; backend session may already be expired
      console.warn("Auth: backend logout failed", err?.message || err);
    }
    // Clean up any legacy token from earlier localStorage-based sessions
    try {
      localStorage.removeItem("ap_token");
    } catch {
      /* storage may be unavailable */
    }
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout, refresh: fetchMe }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
